import React, { Fragment, memo, useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { AppContext } from "../../../components/AppProvider";
import { PostApi1212, PostApi1214 } from "../../../modules/network/padoPost";
import { checkNum10, maxLengthCheck } from "../../../modules/utils/CheckLogic";
import { AfterMealInputLayerMod, DateTimeLayerMod } from "../../Layout";
import SelectDiv from "../../common/Div/SelectDiv";

export default props => {
  const { setModifyDisplay, reloadList, seqNo, targetData } = props;
  return (
    <div
      className="blacklayer-container"
      id="modifyLayer"
      style={{ zIndex: "55", display: "block" }}>
      <div className="bl-blind"></div>
      <BsModifyLayer
        modifyTarget={props.modifyTarget}
        modifyDisplay={props.modifyDisplay}
        setModifyDisplay={setModifyDisplay}
        reloadList={reloadList}
        seqNo={seqNo}
        targetData={targetData}
      />
    </div>
  );
};

const BsModifyLayer = memo(props => {
  const { userinfo, cfg, phonecfg } = useContext(AppContext);
  const [bsDate, setBsDate] = useState(props.targetData.date);
  const [bsTime, setBsTime] = useState(props.targetData.time);
  const [afMealTime, setAfMealTime] = useState(
    props.targetData.column3.split(" ").length > 1
      ? props.targetData.column3.split(" ")[1] != ""
        ? props.targetData.column3.split(" ")[1].split(":")[0] +
          props.targetData.column3.split(" ")[1].split(":")[1]
        : "0200"
      : null
  );
  const [mealType, setMealType] = useState(
    props.targetData.column3.split(" ").length > 1 ? "A" : "B"
  );

  const BsModifyEvent = () => {
    PostApi1212(
      userinfo,
      cfg,
      phonecfg,
      props.seqNo,
      bsDate,
      bsTime,
      mealType,
      mealType === "B" ? null : afMealTime,
      $("#inputData").val()
    )
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          // 리스트 갱신 API
          props.reloadList();
          props.setModifyDisplay(false);
          document
            .getElementsByTagName("body")[0]
            .classList.remove("scrollLock");
        } else {
          alert("수정실패");
        }
      })
      .catch(err => {
        alert("서버에러 혈당 : ", err);
      });
  };

  const inslModifyEvent = () => {
    // userinfo, cfg, phonecfg, seqNo, injctDate, injctTime, mealType, afMealTime, injctForm, injctDose
    PostApi1214(
      userinfo,
      cfg,
      phonecfg,
      props.seqNo,
      bsDate,
      bsTime,
      mealType,
      mealType === "B" ? null : afMealTime,
      "99",
      $("#inputData").val()
    )
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          // 리스트 갱신 API
          props.reloadList();
          props.setModifyDisplay(false);
          document
            .getElementsByTagName("body")[0]
            .classList.remove("scrollLock");
        } else {
          alert("수정실패");
        }
      })
      .catch(err => {
        console.log("서버에러 인슐린 : ", err);
      });
  };

  return (
    <div className="in-layerarea">
      <div className={"blgrn-box vertical"}>
        <div className="doctor-message">
          {/* 식전 식후 선택영역 */}
          <DivFlex>
            <SelectDiv
              textA={["식전", "식후"]}
              id="mealTypeInput"
              defaultData={props.targetData.column3.split(" ")[0]}
              setData={setMealType}
              setAfMealTime={setAfMealTime}
            />
            <div style={{ marginLeft: "auto" }}>
              <DateTimeLayerMod
                setBpcDate={setBsDate}
                setBpcTime={setBsTime}
                viewDate={props.targetData.date}
                viewTime={props.targetData.time}
                viewDay={props.targetData.date2}
                data={props.targetData}
              />
            </div>
          </DivFlex>
          {mealType === "A" && (
            <DivFlex>
              <AfterMealInputLayerMod
                afMealTime={afMealTime === "" ? "0200" : afMealTime}
                setAfMealTime={setAfMealTime}
                mealType={mealType}
                targetData={props.targetData}
              />
            </DivFlex>
          )}

          {/* 식전 식후 선택영역 */}

          {/* 혈당 인풋 박스 */}
          {props.modifyTarget === "BS" ? (
            <BsInputDiv inputData={props.targetData.column1} />
          ) : (
            <InsulinInputDiv inputData={props.targetData.column1} />
          )}
        </div>
        {/* 혈당 인풋 박스 */}

        <div className="btn-area" style={{ float: "right" }}>
          <a
            className="btn-round gray"
            onClick={() => {
              props.setModifyDisplay(false);
              document
                .getElementsByTagName("body")[0]
                .classList.remove("scrollLock");
            }}>
            취소
          </a>
          <a
            className="btn-round wht"
            onClick={() =>
              props.modifyTarget === "BS" ? BsModifyEvent() : inslModifyEvent()
            }>
            확인
          </a>
        </div>
      </div>
    </div>
  );
});

const BsInputDiv = props => {
  const styleBs = {
    height: "46px",
    fontSize: "0.9rem",
    width: "100%",
    border: "1px solid #d0d0d0",
    borderRadius: "7px",
    background: "#fff",
    boxSizing: "border-box",
    float: "right",
    display: "flex",
    padding: "5px",
    paddingLeft: "15px",
    marginTop: "14px",
    marginBottom: "14px",
  };

  useEffect(() => {
    $("#inputData").val(parseInt(props.inputData));
  }, []);

  return (
    <div style={styleBs}>
      <div style={{ width: "85%" }}>
        <input
          type="number"
          pattern="\d*"
          id="inputData"
          style={{ border: "0px", width: "100%", height: "100%" }}
          onChange={e => {
            maxLengthCheck(e, 3);
          }}
        />
      </div>
      <div
        style={{
          width: "10%",
          lineHeight: "35px",
          color: "rgb(156, 156, 156)",
        }}>
        mg/dL
      </div>
    </div>
  );
};

const InsulinInputDiv = props => {
  const [injctDose, setInjctDose] = useState(
    props.inputData ? parseInt(props.inputData) : 1
  );
  const [dynamicDose, setDynamicDose] = useState(
    props.inputData ? parseInt(props.inputData) * 0.01 : 0.01
  );

  useEffect(() => {
    $("#inputData").val(parseInt(props.inputData));
  }, []);

  useEffect(() => {
    if (injctDose) {
      setDynamicDose(0.01 * injctDose);
    }
  }, [injctDose]);

  return (
    <Fragment>
      <div
        style={{
          height: "46px",
          fontSize: "0.9rem",
          width: "100%",
          border: "1px solid #d0d0d0",
          borderRadius: "7px",
          background: "#fff",
          boxSizing: "border-box",
          float: "right",
          display: "flex",
          padding: "5px",
          paddingLeft: "15px",
          marginTop: "14px",
          marginBottom: "14px",
        }}>
        <div style={{ width: "85%" }}>
          <input
            type="number"
            pattern="\d*"
            id="inputData"
            style={{ border: "0px", width: "100%", height: "100%" }}
            onChange={e => {
              maxLengthCheck(e, 3) &&
                (e.target.value
                  ? setInjctDose(e.target.value)
                  : setInjctDose(1));
            }}
          />
        </div>
        <div
          style={{
            width: "10%",
            lineHeight: "35px",
            color: "rgb(156, 156, 156)",
          }}>
          IU
        </div>
      </div>
    </Fragment>
  );
};

const DivFlex = styled.div`
  display: flex;
`;
